/**
 * Rotating brand-panel sentences for the Hotelinking Admin login shell.
 * Index 0 is the anchor line shown when motion is reduced or the viewport is
 * narrow. Edit copy here only. Keep every sentence ≤ 64 characters (enforced
 * by proofs.test.ts). The audience is Hotelinking staff, not customers.
 */
export const ADMIN_PROOFS: readonly string[] = [
  "Every tenant, one console.",
  "From the first meeting to go-live.",
  "Contracts, deals and onboarding in one place.",
  "Every brand, every product, one record.",
  "Work that finds its owner.",
  "Help threads, triaged before you open them.",
  "Know what is live, and what is billed.",
  "Promises made, promises kept.",
  "The whole relationship, end to end.",
  "Built by the team, for the team.",
];
